/**
 * Fetches level leaderboard and (when logged in) current user's best for a scenario.
 * Fails gracefully when offline — returns null, no throw.
 * Uses same-origin /api/ so it works with Vite proxy in dev and PHP on same host in prod.
 */

export interface LevelScoreEntry {
  user_id: string;
  display_name: string;
  score: number;
  best_time_seconds: number;
  player_count: number; // 1–4
  updated_at: string;
}

export interface LevelScoresResponse {
  scores: LevelScoreEntry[];
  my_score: { score: number; best_time_seconds: number; player_count: number } | null;
}

/**
 * Fetch top scores and (if logged in) your score for a scenario.
 * Async, non-blocking. Returns null on network error so the app works offline.
 */
export async function fetchLevelScores(scenarioId: string, limit = 10): Promise<LevelScoresResponse | null> {
  try {
    const res = await fetch(`/api/level-scores.php?scenario_id=${encodeURIComponent(scenarioId)}&limit=${limit}`, {
      credentials: 'include',
    });
    if (!res.ok) return null;
    const data = (await res.json()) as LevelScoresResponse;
    return data;
  } catch {
    return null;
  }
}
